function noEnter() {
    return (evt) => {
        if (evt.keyCode === 13) {
            evt.preventDefault();
            return false;
        }
    };
}
function noHtml() {
    return (evt) => {
        let text = '';
        evt.preventDefault();
        if (evt.clipboardData || evt.originalEvent.clipboardData) {
            text = (evt.originalEvent || evt).clipboardData.getData('text/plain');
        } else if (window.clipboardData) {
            text = window.clipboardData.getData('Text');
        }
        if (document.queryCommandSupported('insertText')) {
            document.execCommand('insertText', false, text);
        } else {
            document.execCommand('paste', false, text);
        }
    };
}

export default {
    bind(el) {
        el.addEventListener('keypress', noEnter());
        el.addEventListener('paste', noHtml());
    },

    unbind(el) {
        el.removeEventListener('keypress', noEnter());
        el.removeEventListener('paste', noHtml());
    },
};
